import RentalListPage from "../common/Rentals/RentalListPage";
import AddPropertyGuide from "./add";
import Share from "./share";
import TableRow from "./row";

const PROPERTY_GUIDE_CONFIG = {
  pageTitle: "Home Guides",
  addButtonLabel: "HOME GUIDE",
  emptyMessage: "No home guides matching your current search or filters.",
  sortOptions: ["updated_at", "name", "pms_id"],
  hasFilters: true,
  filterOptions: {
    destination_id: "No Filter",
    mis_destination_id: "Missing Area Guide",
    pms_id: "No Property ID",
  },
  extraButtons: [
    { label: "Master Home Guide", href: "master-home-guide" },
    { label: "Property Field Values", href: "/property-field-values" },
  ],
  ShowShareComponent: true,
  AddComponent: AddPropertyGuide,
  RowComponent: TableRow,
  ShareComponent: Share,
};

export default () => <RentalListPage config={PROPERTY_GUIDE_CONFIG} />;
